<template>
  <div id="warehouse-registered-payment-method-page" class="payment">
    <div class="text-center">
      <h1 class="payment-title">プレミアムの登録が完了しました</h1>
    </div>
    <div class="payment-content">
      <div class="m-b-xl">
        お手続きありがとうございます。<br>
        プレミアムの登録が完了しました。
      </div>
      <div class="m-b-xl">
        ご利用料金は、ご登録頂いたお支払い方法にて決済させていただきます。<br>
        尚、契約期間満了時も同様にご登録頂いたお支払い方法にて決済させていただき、<br>
        契約期間を自動更新させていただきます。
      </div>
      <div class="flexbox justify-center">
        <button class="btn btn-primary btn-shadow bd-rds-8" @click="$router.push({name: 'Setting', params: {tab: 'plan-info'}})">
          <i class="fa fa-arrow-circle-right fa-lg mr-r-5" aria-hidden="true"></i>
          ご利用プランを確認する
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  data () {
    return {
      sessionId: null
    }
  },
  created () {
    this.sessionId = this.$route.query.session_id
    if (!this.sessionId) {
      this.$router.push('/not-found')
    }
  },
  mounted () {
    let logParams = {
      name: eventCode.settings.plan_info_tab.upgrade_plan_completed,
      properties: {}
    }
    EventService.postTrackLog(logParams)
  }
}
</script>



// WEBPACK FOOTER //
// src/view/setting/UpgradePlanCompleted.vue